import { useEffect, useState } from "react"
import { Navigate } from "react-router-dom"
import { format } from "date-fns"
import NavAppBar from "../components/NavAppBar"
import { useAuth } from "../context/AuthProvider"
import dataService from '../services/Data'
import { Container, CssBaseline, Grid, Box } from "@mui/material"
import FullFeaturedCrudGrid from "../components/FullFeaturedCrudGrid"

export const Consultas = () => {
    const { user } = useAuth()
    const [consultas, setDatos] = useState(null)
    //const [fechaIni, setFechaIni] = useState(new Date())
    //const [fechaFin, setFechaFin] = useState(new Date())
    const [role, setRole] = useState(null)

    dataService.setToken(user.data.token)

    useEffect(() => {
        dataService.listarConsultas(setDatos)
        setRole(user.data.rol)
    }, [])

    const formatCurrency = (value) => {
        if (value === null || value === undefined || isNaN(value)) return '$ 0,00';
        // Convertir a n�mero y manejar decimales
        const number = Number(value).toFixed(2); // Asegura 2 decimales
        // Separar parte entera y decimal
        const [integerPart, decimalPart] = number.split('.');
        // Formatear parte entera con separador de miles (punto)
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        // Combinar con s�mbolo de peso y decimales (coma)
        return `$ ${formattedInteger},${decimalPart}`;
    };

    const columns = [
        { field: 'fecha', headerName: 'FECHA', headerAlign:'center', width: 140, align: 'center', valueFormatter: (value) => format(new Date(value), 'dd/MM/yyyy HH:mm'), type: 'date', editable: false },
        { field: 'vehiculo', headerName: 'CREDITO',headerAlign:'center', width: 220, align: 'left', editable: false },
        { field: 'tipoCredito', headerName: 'TIPO CREDITO',headerAlign:'center', width: 150, align: 'left', editable: false },
        { field: 'modelo', headerName: 'MODELO',headerAlign:'center', width: 200, align: 'left', editable: false },
        { field: 'plazo', headerName: 'CUOTAS',headerAlign:'center', width: 80, align: 'right', editable: false },
        { field: 'importe', headerName: 'CAPITAL',headerAlign:'center', width: 180, align: 'right', valueFormatter: (value) => formatCurrency(value), editable: false },
        { field: 'usuario', headerName: 'USUARIO',headerAlign:'center', width: 230, align: 'left', editable: false }];

    return (
        <>
            <CssBaseline />
            <NavAppBar />
            <Container style={{ maxWidth: 1250 }} >
                <Box display="flex" justifyContent="center" margin="dense">
                    <h2>Consultas Usuarios</h2>
                </Box>
                {consultas != null && consultas.result.datos.length !== 0 && (role === "Administrador" || role === "supervisor") ? (
                    <>
                        {/*<span style={{ height: 50, marginLeft: 3, float: 'right', width: '16%' }}><DatePicker text="Fecha Fin" value={fechaFin} setValue={setFechaFin} /></span> */}
                        {/*<span style={{ height: 50, float: 'right', width: '16%' }}><DatePicker text="Fecha Ini" value={fechaIni} setValue={setFechaIni} /></span> */}
                        <Grid className="contenedor" container spacing={1}>
                            {consultas != null ? (
                                <>
                                    <FullFeaturedCrudGrid rows={consultas.result.datos} columns={columns} showTool={true} hideFoot={false} hideFootPage={false} hideFootRowCount={false} />
                                    <br />
                                </>
                            ) : ""}
                        </Grid>
                    </>) : ""}
            </Container>
        </>
    )
}